export default __webpack_public_path__ + "static/media/eiderdown.a51b7cb9.png";